interface FieldErrorProps {
  error?: string | string[];
}

export function FieldError({ error }: FieldErrorProps) {
  if (!error) return null;
  const msg = Array.isArray(error) ? error[0] : error;
  return <p className="mt-1 text-xs text-destructive">{msg}</p>;
}
